/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

if (typeof Highcharts !== "undefined") {
  Highcharts.setOptions({
    lang: {
      numericSymbols: null,
    },
  });
}

jQuery(document).ready(function ($) {
 /*Buttons for language scroll*/
  $('.navigate-button-soer-slo').click(function () {
    $(this).navigateToContent('page-header');
  });
  $('.navigate-button-soer-eng').click(function () {
    $(this).navigateToContent('view-header');
  });
  /*Function for language scroll*/

  $.fn.navigateToContent = function (content) {
    // Get the content element with the class "test"
    var contentElement = $('.' + content);  
    contentElement.show();
    // Scroll to the content element
    $('html, body').animate({
      scrollTop: contentElement.offset().top
    }, 1000);
  };
  /*END buttons and function*/

  console.log("ready!");
  $("div.form-item.js-form-item input.form-text.form-control")
    .focusin(function () {
      $(
        "div.form-actions.form-group.js-form-wrapper.form-wrapper button.button.js-form-submit.form-submit.btn-default.btn.icon-before"
      ).css({
        "-webkit-transition": "0.2s ease-in-out",
        "-o-transition": "0.2s ease-in-out",
        transition: "0.2s ease-in-out",
        "background-color": "white",
      });
      $(
        "div.form-actions.form-group.js-form-wrapper.form-wrapper button.button.js-form-submit.form-submit.btn-default.btn.icon-before img"
      ).css({
        filter:
          "invert(0%) sepia(93%) saturate(7%) hue-rotate(31deg) brightness(93%) contrast(100%)",
      });
    })
    .focusout(function () {
      $(
        "div.form-actions.form-group.js-form-wrapper.form-wrapper button.button.js-form-submit.form-submit.btn-default.btn.icon-before"
      ).css({
        "-webkit-transition": "0.2s ease-in-out",
        "-o-transition": "0.2s ease-in-out",
        transition: "0.2s ease-in-out",
        "background-color": "rgba(0, 0, 0, 0.1)",
      });
      $(
        "div.form-actions.form-group.js-form-wrapper.form-wrapper button.button.js-form-submit.form-submit.btn-default.btn.icon-before img"
      ).css({
        filter:
          "invert(98%) sepia(100%) saturate(0%) hue-rotate(10deg) brightness(102%) contrast(105%)",
      });
    });
  $(".dropdown-toggle").click(function () {
    $(this).parent().addClass("open");
  });
  // toggle mobile menu
  $("#toggle-more-areas").click(function () {
    $(this).toggleClass("mobile-menu-open");
    $("#mobile-primary-menu").toggleClass("mobile-menu-open");
  });

  $(".collapse-body").click(function () {
    $(this).parents("fieldset").children(".panel-body").slideToggle();
    $(this).parents("legend").toggleClass("body-hidden");
  });

  // excel export
  function ExportToExcel(type, fn, dl) {
    var elt = $(".view-indicators-trend .table").clone();
    elt.find("img").replaceWith(function () {
      return this.alt;
    });
    var wb = XLSX.utils.table_to_book(elt[0], { sheet: "trend" });
    return dl
      ? XLSX.write(wb, { bookType: type, bookSST: true, type: "base64" })
      : XLSX.writeFile(wb, fn || "trend." + (type || "xlsx"));
  }

  $("#exportExcel").click(function (evn) {
    ExportToExcel("xlsx");
  });

  $("#exportExcel").text(Drupal.t("Export excel"));

  /*
    var elt = $('.view-indicators-trend .table').clone();
    elt.find('img').replaceWith(function() { return this.alt; })
    TableExport(document.getElementsByClassName("table"), {
        headers: true,                      // (Boolean), display table headers (th or td elements) in the <thead>, (default: true)
        footers: false,                      // (Boolean), display table footers (th or td elements) in the <tfoot>, (default: false)
        formats: ["xlsx", "csv", "txt"],    // (String[]), filetype(s) for the export, (default: ['xlsx', 'csv', 'txt'])
        filename: "trend",                     // (id, String), filename for the downloaded file, (default: 'id')
        bootstrap: true,                   // (Boolean), style buttons using bootstrap, (default: true)
        exportButtons: true,                // (Boolean), automatically generate the built-in export buttons for each of the specified formats (default: true)
        position: "bottom",                 // (top, bottom), position of the caption element relative to table, (default: 'bottom')
        ignoreRows: null,                   // (Number, Number[]), row indices to exclude from the exported file(s) (default: null)
        ignoreCols: null,                   // (Number, Number[]), column indices to exclude from the exported file(s) (default: null)
        trimWhitespace: true,               // (Boolean), remove all leading/trailing newlines, spaces, and tabs from cell text in the exported file(s) (default: false)
        RTL: false,                         // (Boolean), set direction of the worksheet to right-to-left (default: false)
        sheetname: "trend"                     // (id, String), sheet name for the exported spreadsheet, (default: 'id')
    });*/

  // svg hack to get it inline and then we can change its color
  $('#views-exposed-form-iskalnik-search-block img[src$=".svg"]').each(
    function () {
      var $img = jQuery(this);
      var imgURL = $img.attr("src");
      var attributes = $img.prop("attributes");

      $.get(
        imgURL,
        function (data) {
          // Get the SVG tag, ignore the rest
          var $svg = jQuery(data).find("svg");

          // Remove any invalid XML tags
          $svg = $svg.removeAttr("xmlns:a");

          // Loop through IMG attributes and apply on SVG
          $.each(attributes, function () {
            $svg.attr(this.name, this.value);
          });

          // Replace IMG with SVG
          $img.replaceWith($svg);
        },
        "xml"
      );
    }
  );

  // toggel on focus search button
  $("#edit-search-api-views-fulltext-wrapper input")
    .focusin(function () {
      $("#edit-submit-iskalnik").addClass("focused");
    })
    .focusout(function () {
      $("#edit-submit-iskalnik").removeClass("focused");
    });

  /*document.querySelector('#edit-search-api-fulltext').addEventListener('focus', () => {
      const maxLength = document.querySelector('#edit-search-api-fulltext').getAttribute('maxlength');
      document.querySelector('#edit-submit-search').style.width = `${maxLength}px`;
    });*/

  $(
    ".view-home div.view-content div.views-row-first div.node-article.node-teaser"
  )
    .first()
    .addClass("panel-primary")
    .removeClass("panel-default");

  //    $('#definitionsBody').on('hidden.bs.collapse', function () {
  //      $('#definitionsBody').parent().find('.article-field-label div h2 span.glyphicon').removeClass('glyphicon-chevron-up').addClass('glyphicon-chevron-down');
  //    });
  //    $('#definitionsBody').on('shown.bs.collapse', function () {
  //      $('#definitionsBody').parent().find('.article-field-label div h2 span.glyphicon').removeClass('glyphicon-chevron-down').addClass('glyphicon-chevron-up');
  //    });

  //$('.list-group-item-wrapper button')

  // add open class to open subcategory so we can color background of opened theme
  $(".list-group-item-wrapper button").click(function () {
    if ($(this).hasClass("collapsed")) {
      $(this).parent().addClass("open");
    } else {
      $(this).parent().removeClass("open");
    }
  });

  $(".collapsed .article-field-label h3").addClass("active");

  // collapse button for showing/hiding table for indicator
  $(".collapse").on("hidden.bs.collapse", function () {
    console.log("hidden.bs.collapse");
    $(this)
      .parent()
      .find(".article-field-label h3, .show-table")
      .addClass("active");
    handle_sticky(500);
  });
  $(".collapse").on("shown.bs.collapse", function () {
    $(this)
      .parent()
      .find(".article-field-label h3, .show-table")
      .removeClass("active");
    handle_sticky(500);
  });

  // tabelca add classes
  $(".tablefield, .tabelca").addClass(
    "table-bordered table-hover table table-striped"
  );

  // button for openin menu on < lg screens
  $(
    "#sidebar-wrapper > div > button, .menu-button"
  ).click(function (event) {
    toggle_open_menu();
    event.stopPropagation();
  });

  // click on black overlay also hide menu
  $(".wrapper .main-container").click(function () {
    if ($(this).parents(".wrapper").hasClass("open-menu")) {
      toggle_open_menu();
    }
    if ($("#views-exposed-form-search-page-1").hasClass("open-search")) {
      toggle_open_mobile_search();
    }
  });

  function toggle_open_menu() {
    //$('.main-container').toggleClass('open-menu');
    $("#sidebar-wrapper, #menu-bg").toggleClass("open-menu");
    $("#sidebar-content").toggleClass("visible-lg-block");
    $("#menu-bg").toggleClass("hidden-xs");
    $(".wrapper").toggleClass("open-menu");
    handle_sticky(0);
  }

  function toggle_open_mobile_search() {
    $("#views-exposed-form-search-page-1").toggleClass("open-search");
    $("#views-exposed-form-search-page-1 .views-exposed-form").toggleClass(
      "hidden-xs"
    );
    $("#block-exposedformsearchpage-1 .close-container").toggle();
  }

  // click on search button for mobile
  $("#right-menu-block button.search-button, button.close-button").click(
    function (event) {
      toggle_open_mobile_search();
      event.stopPropagation();
    }
  );

  // stop propagating block click
  $("#views-exposed-form-search-page-1").click(function (event) {
    event.stopPropagation();
  });

  // color search submit button accordingly
  $("#edit-submit-iskalnik").addClass("btn-primary");

  var el;
  if ($("div.main-container").height() > $("div#sidebar-wrapper").height()) {
    el = $("div#sidebar-wrapper");
  } else {
    el = $("div.main-container");
  }
  el.stick_in_parent();

  $(".list-group-item-wrapper button, #secondary-menu a.collapse-body").click(
    function () {
      handle_sticky(1000);
    }
  );

  /*
        Twitter iframe dissapearing fix
     */
  $("div.main-container").bind("sticky_kit:unstick", function (event) {
    twitter_handle();
  });

  $("div.main-container").bind("sticky_kit:stick", function (event) {
    twitter_handle();
  });

  $("div.main-container").bind("sticky_kit:detach", function (event) {
    twitter_handle();
  });

  $(".article-field-content table").addClass(
    "table table-bordered table-striped table-hover"
  );

  /*$(document.body).bind(
        'sticky_kit:recalc',
        function (event) {
            twitter_handle();
        }
    );*/

  var rtime;
  var timeout = false;
  var delta = 200;
  $(window).resize(function () {
    rtime = new Date();
    if (timeout === false) {
      timeout = true;
      setTimeout(resizeend, delta);
    }
  });

  function resizeend() {
    if (new Date() - rtime < delta) {
      setTimeout(resizeend, delta);
    } else {
      timeout = false;
      twitter_handle();
      //alert('Done resizing');
    }
  }

  function twitter_handle() {
    if ($("#twitter-arso-timeline iframe").length) {
      // use this if you are using id to check
      // it exists
      $("#twitter-arso-timeline iframe, #twitter-arso-timeline a").remove();
      $("#twitter-arso-timeline").append(
        '<a class="twitter-timeline" data-height="600" data-link-color="#76a781" href="https://twitter.com/EionetA?ref_src=twsrc%5Etfw">KOS Tweeti</a>'
      );
      twttr.widgets.load();
    }

    if ($("#twitter-arso-mobile-timeline iframe").length) {
      // use this if you are using id to check
      // it exists
      $(
        "#twitter-arso-mobile-timeline iframe, #twitter-arso-mobile-timeline a"
      ).remove();
      $("#twitter-arso-mobile-timeline").append(
        '<a class="twitter-timeline" data-height="600" data-link-color="#76a781" href="https://twitter.com/EionetA?ref_src=twsrc%5Etfw">KOS Tweeti</a>'
      );
      twttr.widgets.load();
    }
  }
  /*
        End Tiwter fix
     */

  // resize may happen becouse of twitter loaded
  /*twttr.events.bind(
        'rendered',
        function (event) {
            console.log("Created widget", event.target.id);
            $(document.body).trigger("sticky_kit:recalc");
            console.log("recalc");
        }
    );*/

  function handle_sticky(delta) {
    console.log("sticky");

    var el1 = $("div#sidebar-wrapper");
    //var el1 = $('div#sidebar-container');
    //var el2 = $('div.main-subcontainer');
    var el2 = $("div.main-container");

    setTimeout(function () {
      if (el1.data("sticky_kit")) {
        if (el1.height() > el2.height()) {
          el1.trigger("sticky_kit:detach");
          el2.stick_in_parent({
            parent: ".wrapper", // note: we must now manually provide the parent
            //spacer: ".main-container",
          });
          console.log("reattach");
        } else {
          $(document.body).trigger("sticky_kit:recalc");
          console.log("recalc");
          //twttr.widgets.load()
        }
      } else {
        if (el2.height() > el1.height()) {
          el2.trigger("sticky_kit:detach");
          el1.stick_in_parent({
            parent: ".wrapper", // note: we must now manually provide the parent
            //spacer: "#sidebar-wrapper",
          });
          console.log("reattach");
        } else {
          $(document.body).trigger("sticky_kit:recalc");
          console.log("recalc");
          //twttr.widgets.load()
        }
      }
    }, delta);
  }

  (function ($, window, document, undefined) {
    "use strict";

    var elSelector = "#block-exposedformsearchpage-1",
      elClassHidden = "header--hidden",
      elClassNarrow = "header--narrow",
      elNarrowOffset = 50,
      throttleTimeout = 500,
      $element = $(elSelector);

    if (!$element.length) return true;

    var $window = $(window),
      wHeight = 0,
      wScrollCurrent = 0,
      wScrollBefore = 0,
      wScrollDiff = 0,
      $document = $(document),
      dHeight = 0,
      throttle = function (delay, fn) {
        var last, deferTimer;
        return function () {
          var context = this,
            args = arguments,
            now = +new Date();
          if (last && now < last + delay) {
            clearTimeout(deferTimer);
            deferTimer = setTimeout(function () {
              last = now;
              fn.apply(context, args);
            }, delay);
          } else {
            last = now;
            fn.apply(context, args);
          }
        };
      };

    $window.on(
      "scroll",
      throttle(throttleTimeout, function () {
        dHeight = $document.height();
        wHeight = $window.height();
        wScrollCurrent = $window.scrollTop();
        wScrollDiff = wScrollBefore - wScrollCurrent;

        $element.toggleClass(elClassNarrow, wScrollCurrent > elNarrowOffset); // toggles "narrow" classname

        if (
          (" " + $element.className + " ")
            .replace(/[\t\r\n\f]/g, " ")
            .indexOf(" mobile-sidemenu-is-open ") > -1
        ) {
          console.log("go");
          element.css("position", "absolute");
          element.css("top", wScrollCurrent);
        }

        if (wScrollCurrent <= 0)
          // scrolled to the very top; element sticks to the top
          $element.removeClass(elClassHidden);
        else if (wScrollDiff > 0 && $element.hasClass(elClassHidden))
          // scrolled up; element slides in
          $element.removeClass(elClassHidden);
        else if (wScrollDiff < 0) {
          // scrolled down
          if (
            wScrollCurrent + wHeight >= dHeight &&
            $element.hasClass(elClassHidden)
          )
            // scrolled to the very bottom; element slides in
            $element.removeClass(elClassHidden);
          // scrolled down; element slides out
          else $element.addClass(elClassHidden);
        }

        wScrollBefore = wScrollCurrent;
      })
    );
  })(jQuery, window, document);
});
